export default __webpack_public_path__ + "static/male2-14282fd18bab87535b83eb09826ef890.png";